// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUi from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'/* 引入element样式 */
import '@/assets/css/main.css'
import '@/styles/reset.css'/* 清除默认样式 */
import '@/styles/index.css'/* 清除默认样式 */
import permission from '@/untils/permission'


import '@/Index.css'
import 'babel-polyfill'
Vue.config.productionTip = false
Vue.use(ElementUi)
Vue.use(permission)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js